import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { Subject, BehaviorSubject, merge } from 'rxjs';
import { DataSource } from '@angular/cdk/table';
import { takeUntil, tap } from 'rxjs/operators';
import { MatPaginator, MatSort, MatDialog, MatSnackBar } from '@angular/material';
var RequestListComponent = /** @class */ (function () {
    function RequestListComponent(_requestService, _matDialog, _matSnackBar, _translate, _translationLoader, _companyService) {
        this._requestService = _requestService;
        this._matDialog = _matDialog;
        this._matSnackBar = _matSnackBar;
        this._translate = _translate;
        this._translationLoader = _translationLoader;
        this._companyService = _companyService;
        this.displayedColumns = ['request', 'status', 'comment', 'pick_up_date', 'created_at'];
        this.totalPages = 2;
        this.totalElements = 0;
        this.sortField = 'created_at';
        this.sordOrder = 'desc';
        this.pageSize = 10;
        this.lang = 'sr';
        this._unsubscribeAll = new Subject();
    }
    RequestListComponent.prototype.getTranslations = function () {
        var _this = this;
        this._translationLoader.getLastLang()
            .then(function (response) {
            _this.lang = response['code'];
            _this._translationLoader.getTranslations(_this.lang, '23');
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function () {
        }, function (err) {
        });
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    RequestListComponent.prototype.loadRequestsPage = function () {
        console.log('REQUEST LOAD');
        this.dataSource.loadRequests(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active || 'created_at', this.sort.direction || 'desc', '', this.company.id);
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    RequestListComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.dataSource = new FilesDataSource(this._requestService);
        this._companyService.getActiveCompany()
            .then(function (response) {
            _this.company = response;
            console.log(_this.company);
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function () {
            _this.dataSource.loadRequests(1, _this.pageSize, _this.sortField, _this.sordOrder, '', _this.company.id);
        }, function (err) {
        });
        this._requestService.onRequestsChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function () {
            _this._companyService.getActiveCompany()
                .then(function (response) {
                _this.company = response;
            })
                .catch(function (err) { return Promise.reject(err); })
                .then(function () {
                _this.loadRequestsPage();
            }, function (err) {
            });
        });
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (value) {
            _this.getTranslations();
        });
        this._companyService.onCompanyChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function () {
            _this._companyService.getActiveCompany()
                .then(function (response) {
                _this.company = response;
            })
                .catch(function (err) { return Promise.reject(err); })
                .then(function () {
                _this.loadRequestsPage();
            }, function (err) {
            });
        });
        this.getTranslations();
    };
    RequestListComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // reset the paginator after sorting
        this.sort.sortChange.subscribe(function () { return _this.paginator.pageIndex = 0; });
        // on sort or paginate events, load a new page
        merge(this.sort.sortChange, this.paginator.page)
            .pipe(tap(function () { return _this.loadRequestsPage(); }))
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe();
    };
    RequestListComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    };
    return RequestListComponent;
}());
export { RequestListComponent };
// Custom Angular CDK Data Source
var FilesDataSource = /** @class */ (function (_super) {
    tslib_1.__extends(FilesDataSource, _super);
    /**
     * Constructor
     *
     * @param {RequestService} _requestService
     */
    function FilesDataSource(_requestService) {
        var _this = _super.call(this) || this;
        _this._requestService = _requestService;
        _this.requestsSubject = new BehaviorSubject([]);
        _this.loadingSubject = new BehaviorSubject(false);
        _this.loading$ = _this.loadingSubject.asObservable();
        return _this;
    }
    FilesDataSource.prototype.connect = function () {
        return this.requestsSubject.asObservable();
    };
    FilesDataSource.prototype.disconnect = function () {
        this.requestsSubject.complete();
        this.loadingSubject.complete();
    };
    FilesDataSource.prototype.setData = function (data) {
        this.requestsSubject.next(data);
        this.loadingSubject.next(false);
    };
    FilesDataSource.prototype.loadRequests = function (page, limit, orderBy, order, search, company) {
        var _this = this;
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = 20; }
        if (orderBy === void 0) { orderBy = 'created_at'; }
        if (order === void 0) { order = 'desc'; }
        if (search === void 0) { search = ''; }
        if (company === void 0) { company = 1; }
        this.loadingSubject.next(true);
        this._requestService.listSubmittedRequests(company, page, limit, orderBy, order, search).then(function (response) {
            _this.requestsSubject.next(response.data);
            _this.loadingSubject.next(false);
        });
    };
    return FilesDataSource;
}(DataSource));
export { FilesDataSource };
